<app-draggable-modal-wrapper>
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>
        <p [innerHtml]="data.content"></p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button
            class="!rounded-full m-2"
            color="primary"
            type="button"
            mat-raised-button
            (click)="close()"
            cdkFocusInitial
        >
            Close
        </button>
    </mat-dialog-actions>
</app-draggable-modal-wrapper>
